import { render, staticRenderFns } from "./author-item.vue?vue&type=template&id=53c4f2c4&"
import script from "./author-item.vue?vue&type=script&lang=js&"
export * from "./author-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports